export function getAppliancesList(hierarchyMenu){
    let result = [];
    let idx = 0;

    if (hierarchyMenu.children) {
      const parentLength = hierarchyMenu.children.length;
      for (idx = 0; idx < parentLength; idx++) {
        if (hierarchyMenu.children[idx].isLeaf) {
          result.push({
            ID: hierarchyMenu.children[idx].data.ID_appliance
          })
        } else {
          getAppliancesList(hierarchyMenu.children[idx]).forEach(appliance => {
            result.push(appliance);
          });
        }
      }
    }
    return result;
  };